/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type PreviewStepRenderStatus = typeof PreviewStepRenderStatus[keyof typeof PreviewStepRenderStatus];


export const PreviewStepRenderStatus = {
  pending: 'pending',
  generating: 'generating',
  rendered: 'rendered',
  failed: 'failed',
} as const;
